export default {
  name: 'user-survey',
  translationKey: 'user-survey-module',
  routePrefix: 'user-survey',
  routeNamePrefix: 'user-survey',
  directRoutesAvailable: false,
}
